import * as THREE from 'three';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import SceneCameraController from '../classes/SceneCameraController';
import { RenderLayers } from '../globals'
import ScopeCamera from '../classes/Camera';
import ScopeLight from '../classes/Light';
import Callout from '../classes/Callout';
import Text3D from '../classes/Text3D';
import WorkspaceManager from '../classes/WorkspaceManager';

export default function ObjectPreview(props)
{
	const dispatch = useDispatch(); 
	const canvasRef = useRef(null);
	const selfRef = useRef(null);

	const camera = new THREE.PerspectiveCamera(60, 1.0, 0.01, 10000);
	
	useEffect(() =>
	{
		WorkspaceManager.setObjectPreviewRenderData(props.parentGuid, { 
			context: canvasRef.current.getContext("2d"),
			camera: camera, 
			objects: props.objects ?? [] 
		});

		return () => 
		{	
			WorkspaceManager.clearObjectPreviewRenderData(props.parentGuid); 
		};

	}, []); 
	
	useEffect(() =>
	{
		camera.layers.set(RenderLayers.ObjectPreview);

		WorkspaceManager.setObjectPreviewRenderData(props.parentGuid, { 
			context: canvasRef.current.getContext("2d"),
			camera: camera, 
			objects: props.objects ?? [] 
		});

		let objectsToFocus = [];

		if(props.objects)
		{
			for(const object of props.objects)
			{
				object.traverse(function (child)
				{ 		
					if(!(!child.geometry || child instanceof ScopeCamera || child instanceof ScopeLight || child instanceof Text3D || child instanceof Callout))
					{
						objectsToFocus.push(child);
					}
				});
			}
		}

		camera.position.set(1, 1, 1);
		const cameraController = new SceneCameraController(camera);
		camera.lookAt(cameraController.anchor);
		cameraController.focus(objectsToFocus);
		camera.position.copy(cameraController.animationTargetPosition);
		camera.lookAt(cameraController.anchor);
		camera.userData.renderIsDirty = true;

	}, [props.objects]); 

	return (
		<div
			ref={selfRef}>
			<canvas 
				ref={canvasRef}	
				height={256}
				width={256}
				data-viewport={true}
				style={{
					width: "256px",
					height: "256px",
					border: "1px solid black",
				}}
			/>
		</div>	
	);
}

